module.exports = __webpack_public_path__ + "static/mountains-1db00c340d24c357546f4597a1686b7b.svg";